import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=68586cc8&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./CreateUser.vue?vue&type=style&index=0&id=68586cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68586cc8",
  null
  
)

export default component.exports